export const STAFF_MANAGEMENT_PERMISSIONS = [
  "add staff",
  "edit staff",
  "activate staff",
  "deactivate staff",
  "delete staff",
  "update staff",
  "resend invitation to staff",
];

export const ORDER_PERMISSIONS = ["view orders", "update order status"];

export const RELOCATION_PERMISSIONS = [
  "view relocation orders",
  "accept relocation order",
  "reject relocation order",
  "send relocation counter offer",
];

export const ORDER_MANAGEMENT_PERMISSIONS = [
  ...ORDER_PERMISSIONS,
  ...RELOCATION_PERMISSIONS,
];

export const SUBSCRIPTION_PERMISSIONS = [
  "view subscription",
  "renew subscription",
  "upgrade subscription",
  "cancel subscription",
];

export const DASHBOARD_PERMISSIONS = ["view dashboard"];

export const MESSAGE_PERMISSIONS = ["view message", "send message to client"];

export const FLEET_MANAGEMENT_PERMISSIONS = [
  "view fleets",
  "add fleet",
  "edit fleet",
  "delete fleet",
];
